import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-021abb06")

_pushScopeId("data-v-021abb06")
const _hoisted_1 = { class: "p-d-flex p-mb-6" }
const _hoisted_2 = { class: "sub-tabview" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Histogram = _resolveComponent("Histogram")!
  const _component_Distribution = _resolveComponent("Distribution")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "cus-card" }, {
    content: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Button, {
            label: _ctx.$t('demand.forecast.eda.histogram.title'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = 2)),
            class: _ctx.getCssClass(2)
          }, null, 8, ["label", "class"]),
          _createVNode(_component_Button, {
            label: _ctx.$t('demand.forecast.eda.distribution.title'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.active = 3)),
            class: _ctx.getCssClass(3)
          }, null, 8, ["label", "class"])
        ])
      ]),
      (_ctx.active == 2)
        ? (_openBlock(), _createBlock(_component_Histogram, {
            key: 0,
            data: _ctx.histogramChartData
          }, null, 8, ["data"]))
        : _createCommentVNode("", true),
      (_ctx.active == 3)
        ? (_openBlock(), _createBlock(_component_Distribution, {
            key: 1,
            data: _ctx.distributionChartData
          }, null, 8, ["data"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})